angular.module('unica_media_upload.media_controllers')

.controller('MediaUploadListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal, Lightbox,
	MediaUploadListService, MediaUploadDeleteService, MediaUploadEditService
) {

	$scope.mediaList = [];
	$scope.limit  = 11;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.tiles = [];

	$scope.loadMedia = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		MediaUploadListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset, 'pending' )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.mediaList = $scope.mediaList.concat( data );

					$scope.tiles = $scope.tiles.concat( buildGridModel(data, {
						id: '', image : '', title: '', status: ''
					}) );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadMedia();

	$scope.openLightboxModal = function (index) {
		Lightbox.openModal($scope.mediaList, index);
	};

	$rootScope.$on( 'media_deleted', function(event, data) {

	});

	function buildGridModel(medias, tileTmpl) {
		var it,
			results = [ ],
			j = 0;

		angular.forEach(medias, function(md) {

			it = angular.extend({}, tileTmpl);
			it.id      		= md.id;
			it.image   		= md.thumb;
			it.title  		= md.orig_filename;
			it.type    		= ( md.type ? md.type : 'other');
			it.status  		= md.status;
			it.user_id   	= md.user_id;
			it.span    		= { row : 1, col : 1 };

			if ( j == 11 ) {
				j = 0;
			}

			switch ( j+1 ) {
				case 1:
					it.span.row = it.span.col = 2;
					break;
				case 4:
					it.span.col = 2;
					break;

				case 5:
					it.span.row = it.span.col = 2;
					break;
			}

			j++;

			results.push(it);
		});

		return results;
	}


	$scope.deleteMediaUpload = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$confirm({
			title: 'Sei sicuro di voler eliminare questo media?',
			text: 'Confermi la cancellazione del media?'
		}).then(function() {

			$scope.showLoader();
			MediaUploadDeleteService
				.delete( media.id  )
				.then(function() {
					$scope.hideLoader();

					angular.forEach($scope.mediaList, function(media, key) {
						if ( media.id === mediaId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.id === mediaId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media eliminato con successo!', '');
				});

		});
	};


	$scope.changeMediaUploadStatus = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$scope.showLoader();

		var mediaData = {
			status: ( media.status === 'visible' ? 'hidden' : 'visible' )
		};

		MediaUploadEditService
			.updateStatus( media.id, mediaData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if (m.id === mediaId) {
							$scope.mediaList[key] = data;
						}
					});

					angular.forEach($scope.tiles, function(t, key) {
						if (t.id === mediaId) {
							t.status = data.status;
							$scope.tiles[key] = t;
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};


	$scope.approveMediaUpload = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$scope.showLoader();

		MediaUploadEditService
			.approveMedia( media.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(media, key) {
						if ( media.id === mediaId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.id === mediaId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};


	$scope.declineMediaUpload = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$scope.showLoader();

		MediaUploadEditService
			.declineMedia( media.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(media, key) {
						if ( media.id === mediaId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.id === mediaId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};

	$scope.showDelete = true;
	if ( sessionStorage.getItem('sub_from_admin_archive') ) {
		sessionStorage.removeItem('sub_from_admin_archive');
		$scope.showDelete = false;
	}

})

.controller('LightboxController', function ($rootScope, $scope, Lightbox) {

});